export default __webpack_public_path__ + "static/media/icon_E.fcc6cef9.svg";